import React, { FC, useCallback } from "react";
import mapUtils from "../../../utils/map";
import style from "../../../styles/tileDownloaderStyle";
import { useMap } from "../../../App";
import { DownloadState } from "../MapDownloadPage";

const MapDownloadStep1: FC<{ onNext: (values: Partial<DownloadState>) => void; onBack: () => void }> = ({ onNext, onBack }) => {
  const map = useMap()!;

  const buttonNextClick = useCallback(() => {
    const view = map.getView();
    const extent = view.calculateExtent(map.getSize());
    const startZoom = mapUtils.getCurrentZoom(map);

    onNext({ extent, startZoom });
  }, [map, onNext]);

  const css = style;

  return (
    <div>
      <p>Adjust the map to cover the area to download for offline use</p>

      <button onClick={onBack} className="button button-fill pull-left" style={css.buttonConfirm}>
        CANCEL
      </button>
      <button onClick={buttonNextClick} className="button button-fill pull-right" style={css.buttonConfirm}>
        NEXT
      </button>
    </div>
  );
};

export default MapDownloadStep1;
